import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Spin } from 'antd';
import axiosClient from './api/axiosClient';
import { tokenService } from './services/tokenService';
import Authlogin from "./pages/auth/login.js";
import Dashboard from "./pages/dash/dashboard.js";
import { MemberCreate } from "./pages/members/member-create.js";
import { MembersView } from "./pages/members/members-view.js";
import { TrainerCreate } from "./pages/trainers/trainer-create.js";
import { TrainersView } from "./pages/trainers/trainers-view.js";
import { MemberEdit } from "./pages/members/edit/member-edit.js";
import { TrainerEdit } from "./pages/trainers/edit/trainer-edit.js";
import { MemberView } from "./pages/members/view/member-view.js";
import { TrainerView } from "./pages/trainers/view/trainer-view.js";
import Inventory from "./pages/inventory/inventory.js";
import AddInventory from './pages/inventory/add-item.js';
import EditInventoryItem from './pages/inventory/edit/edit-item.js';
import CreateRecord from './pages/inventory/records/create-record.js';
import Records from './pages/inventory/records/records.js';
import EditRecord from './pages/inventory/records/edit-record.js';
import SalesItems from './pages/sales/sales-items.js';
import AddSalesItem from './pages/sales/add-sales-item.js';
import EditSalesItem from './pages/sales/edit/edit-sales-item.js';
import Invoices from './pages/invoices/invoices.js';
import CreateInvoice from './pages/invoices/create-invoice.js';
import ViewInvoice from './pages/invoices/view-invoice.js';
import ReportsDashboard from './pages/reports/ReportsDashboard.js';
import MemberDetailedReport from './pages/reports/MemberDetailedReport.js';
import TrainerDetailedReport from './pages/reports/TrainerDetailedReport.js';
import SalesItemReport from './pages/reports/SalesItemReport.js';
import InventoryReport from './pages/reports/InventoryReport.js';
import InventoryActivityReport from './pages/reports/InventoryActivityReport.js';
import CategoryManagement from './pages/master/CategoryManagement.js';
import SalesMonthlySummary from './pages/reports/SalesMonthlySummary.js';
import MonthlySalesDetailsReport from './pages/reports/MonthlySalesDetailsReport.js';
import PaymentDetailsReport from './pages/reports/PaymentDetailsReport.js';
import TypeManagement from './pages/master/TypeManagement.js';

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      const token = tokenService.getAccessToken();
      if (!token) {
        try {
          const response = await axiosClient.post('/user/refresh_token.php');
          if (response.status === 200 && response.data.access_token) {
            tokenService.setAccessToken(response.data.access_token);
          }
        } catch (error) {
          console.log("Silent refresh failed", error);
        }
      }
      setLoading(false);
    };

    checkAuth();
  }, []);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" tip="Loading..." />
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Authlogin />} />
        <Route path="/login" element={<Authlogin />} />
        <Route path="/dash" element={<Dashboard />} />

        <Route path="/members/create" element={<MemberCreate />} />
        <Route path="/members/view" element={<MembersView />} />
        <Route path="/members/view/:id" element={<MemberView />} />
        <Route path="/members/edit/:id" element={<MemberEdit />} />

        <Route path="/trainers/create" element={<TrainerCreate />} />
        <Route path="/trainers/view" element={<TrainersView />} />
        <Route path="/trainers/view/:id" element={<TrainerView />} />
        <Route path="/trainers/edit/:id" element={<TrainerEdit />} />

        <Route path="/inventory/itemList" element={<Inventory />} />
        <Route path="/inventory/add" element={<AddInventory />} />
        <Route path="/inventory/edit/:id" element={<EditInventoryItem />} />
        <Route path="/inventory/records/create" element={<CreateRecord />} />
        <Route path="/inventory/records" element={<Records />} />
        <Route path="/inventory/records/edit/:id" element={<EditRecord />} />

        <Route path="/sales/items" element={<SalesItems />} />
        <Route path="/sales/add" element={<AddSalesItem />} />
        <Route path="/sales/edit/:id" element={<EditSalesItem />} />

        <Route path="/invoices" element={<Invoices />} />
        <Route path="/invoices/create" element={<CreateInvoice />} />
        <Route path="/invoices/view/:id" element={<ViewInvoice />} />
        
        <Route path="/reports" element={<ReportsDashboard />} />
        <Route path="/reports/members-detailed" element={<MemberDetailedReport />} />
        <Route path="/reports/trainers-detailed" element={<TrainerDetailedReport />} />
        <Route path="/reports/sales-items" element={<SalesItemReport />} />
        <Route path="/reports/inventory" element={<InventoryReport />} />
        <Route path="/reports/inventory-activity" element={<InventoryActivityReport />} />
        <Route path="/reports/sales-summary" element={<SalesMonthlySummary />} />
        <Route path="/reports/monthly-sales-details" element={<MonthlySalesDetailsReport />} />
        <Route path="/reports/payment-details" element={<PaymentDetailsReport />} />
        
        {/* Master Data */}
        <Route path="/master/categories" element={<CategoryManagement />} />
        <Route path="/master/types" element={<TypeManagement />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;